<template>
  <div class="user-case-container">
    <div class="user-case-title">客户案例</div>
    <div class="user-case-main">
      <div class="emb" ref="embRef">
        <div class="emb_container">
          <div class="user-case-item" v-for="item in customerCaseList" :key="item.id" @click="handleDetails(item.id)">
            <div class="item-img">
              <imgContainer :src="item.caseCover" />
            </div>
            <div class="item-content">
              <div class="item-content-name">{{ item.caseName }}</div>
              <div class="item-content-txt" :title="item.caseIntroduction">{{ handleChara(item.caseIntroduction,87) }}</div>
              <div class="item-content-btn">了解更多</div>
              <div class="item-content-time">
                <div class="content-time-name">{{ item.customerName }}</div>
                <div class="content-time-text">{{ formatDayYYYYMMDD(item.createTime) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {getCustomerCaseList} from "@/api/apiHome";
import {onBeforeUnmount, onMounted, ref} from "vue";
import {handleChara} from "@/utils/title";
import {formatDayYYYYMMDD} from "@/utils/day";
import embCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'
import router from "@/router";
import imgContainer from '@/components/imgContainer/index.vue'

const embRef = ref(null)
const embApi = ref(null)
const customerCaseList = ref([])
const queryConsultationList = async () => {
  const {code, data} = await getCustomerCaseList("");
  if (code === 200) {
    customerCaseList.value = data;
  }
}
const handleDetails = (id) => {
  router.push('/caseDetails?id='+id)
}
// 初始化轮播
onMounted(() => {
  if (!embRef.value) return
  //初始化时传入自动播放插件
  embApi.value = embCarousel(embRef.value, {
    loop: true,
    align: 'center',
    // v8版本中，自动播放选项直接放在主配置中
    autoplay: {
      delay: 3000,
      stopOnInteraction: false
    }
  }, [Autoplay()])
})

// 销毁实例
onBeforeUnmount(() => {
  embApi.value?.destroy()
})
queryConsultationList()
</script>

<style scoped lang="scss">
.user-case-container{
  padding: 70px 0;
  box-sizing: border-box;
}
.user-case-title {
  font-weight: bold;
  font-size: 28px;
  color: #242424;
  position: relative;
  text-align: center;
}

.user-case-title::after {
  content: "";
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: 52px;
  height: 4px;
  background: #0048A9;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.user-case-main {
  width: 1220px;
  height: 300px;
  margin: 50px  auto 0 auto;
}

/* 样式保持不变 */
.emb {
  position: relative;
  width: 1220px;
  height: 300px;
  overflow: hidden;
}

.emb_container {
  display: flex;
  gap: 10px;
  width: 1220px;
  height: 300px;
}

.user-case-item {
  width: 1200px;
  height: 280px;
  flex: 0 0 98%;
  padding: 20px;
  margin: 10px;
  display: flex;
  cursor: pointer;
  box-sizing: border-box;
  box-shadow: 0 2px 9px 0 rgba(0,0,0,0.1);
}

.item-img {
  width: 512px;
  height: 240px;
  margin-right: 30px;
}
.item-content{
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.item-content-name {
  width: 100%;
  font-weight: bold;
  font-size: 22px;
  color: #242424;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-content-txt {
  font-size: 20px;
  color: #797979;
  margin: 14px 0 20px 0;
}

.item-content-btn {
  width: 116px;
  height: 44px;
  text-align: center;
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid #0048A9;
  font-size: 20px;
  color: #0048A9;
  margin-bottom: 14px;
  line-height: 44px;
}

.item-content-time {
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  color: #797979;
}
</style>

